var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form bid_form" },
    [
      _c("v-modal-contents", {
        ref: "modal_contents_agree",
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title mt-30 pl-3 " }, [
                  _c("div", { staticClass: "h2_title" }, [
                    _vm._v("Пользовательское соглашение!"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use mt-30 " }, [
                  _c("p", { staticClass: "red" }, [
                    _vm._v("ТЕКСТ НАХОДИТСЯ В РАЗРАБОТКЕ"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-30" }, [
                    _c(
                      "button",
                      {
                        staticClass: "px-30 btn_bordered ",
                        on: {
                          click: function ($event) {
                            return _vm.$refs.modal_contents_agree.modal_open()
                          },
                        },
                      },
                      [_vm._v("\n            Прочитал\n          ")]
                    ),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("v-modal-contents", {
        ref: "modal_contents_successfully",
        staticClass: "modal_contents_successfully",
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title mt-30 pl-3 " }, [
                  _c("div", { staticClass: "h2_title" }, [
                    _vm._v("Заказать образцы!"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use mt-30 " }, [
                  _c("p", { staticClass: "green_messs" }, [
                    _vm._v("Сообщение отправлено!"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "nr_container_content" }, [
        _c(
          "div",
          { staticClass: "form__inner" },
          [
            _c("h2", { staticClass: "form__title" }, [
              _vm._v("\n        Заказать образцы\n      "),
            ]),
            _vm._v(" "),
            _vm._t("sm-title"),
            _vm._v(" "),
            _c(
              "v-form",
              {
                ref: "form_inner",
                staticClass: "form__content",
                model: {
                  value: _vm.valid,
                  callback: function ($$v) {
                    _vm.valid = $$v
                  },
                  expression: "valid",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "form__box" },
                  [
                    _c("v-text-field", {
                      staticClass: "form__input",
                      attrs: { rules: _vm.nameRules },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n              Ваше имя *\n            "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.name,
                        callback: function ($$v) {
                          _vm.name = $$v
                        },
                        expression: "name",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      staticClass: "form__input",
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n              Название вашей компании\n            "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.company,
                        callback: function ($$v) {
                          _vm.company = $$v
                        },
                        expression: "company",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      staticClass: "form__input",
                      attrs: { rules: _vm.cityRules },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n              Ваш город *\n            "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.city,
                        callback: function ($$v) {
                          _vm.city = $$v
                        },
                        expression: "city",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form__box" },
                  [
                    _c("v-text-field", {
                      staticClass: "form__input",
                      attrs: { rules: _vm.tel_Rules },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n              Ваш телефон\n            "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.tel,
                        callback: function ($$v) {
                          _vm.tel = $$v
                        },
                        expression: "tel",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-text-field", {
                      staticClass: "form__input",
                      attrs: { rules: _vm.mailRules },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n              Ваш e-mail *\n            "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.mail,
                        callback: function ($$v) {
                          _vm.mail = $$v
                        },
                        expression: "mail",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form__box" },
                  [
                    _c("v-textarea", {
                      staticClass: "form__input",
                      attrs: { rows: "2", "no-resize": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "label",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n              Ваше обращение\n            "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                      model: {
                        value: _vm.message,
                        callback: function ($$v) {
                          _vm.message = $$v
                        },
                        expression: "message",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form__box" }, [
                  _c("div", { staticClass: "form__box_info mt-2" }, [
                    _vm._v(
                      "\n            *Укажите ваши пожелания: размер шпули, количество бобин образцов, толщина нити, цвет нити, вес в кг нити\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "form__policy mt-3" }, [
                    _vm._v(
                      "\n        Нажимая кнопку отправить, вы соглашаетесь с нашей\n        "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "form__link",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            return _vm.$refs.modal_contents_agree.modal_open(
                              "scroll_false"
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          политикой обработки данных\n        "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "form__button",
                      attrs: { disabled: !_vm.valid },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.send_form.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("\n            Отправить\n          ")]
                  ),
                ]),
              ]
            ),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }